/**
 * Lightweight audit log shim for WP-1.
 *
 * The platform audit contract (`SCENE_ITEMS_SDK_SPEC.md` §2.6) is still
 * under design (see masterplan §11.3). Until it lands, mutating tool
 * actions emit through this in-memory ring buffer + `console.info`. The
 * real audit forwarder will replace this module without changing the
 * call sites.
 */

export interface AuditEntry {
  ts: string;
  actor: string;
  tenant: string;
  gtwinId: string;
  action: string;
  target: string | null;
  parentVersion?: number;
  newVersion?: number;
  details?: Record<string, unknown>;
}

const ring: AuditEntry[] = [];
const MAX_ENTRIES = 200;

export interface AuditInput {
  actor?: string;
  tenant?: string;
  gtwinId: string;
  action: string;
  target?: string | null;
  parentVersion?: number;
  newVersion?: number;
  details?: Record<string, unknown>;
}

export function recordAudit(input: AuditInput): AuditEntry {
  const entry: AuditEntry = {
    ts: new Date().toISOString(),
    actor: input.actor ?? "geoviewer",
    tenant: input.tenant ?? "dev-tenant",
    gtwinId: input.gtwinId,
    action: input.action,
    target: input.target ?? null,
    parentVersion: input.parentVersion,
    newVersion: input.newVersion,
    details: input.details,
  };
  ring.push(entry);
  if (ring.length > MAX_ENTRIES) ring.shift();
  if (typeof console !== "undefined" && typeof console.info === "function") {
    console.info(
      `[audit] ${entry.action} gtwin=${entry.gtwinId} target=${entry.target ?? "-"}`,
      entry.details ?? {},
    );
  }
  return entry;
}

export function getAuditEntries(): readonly AuditEntry[] {
  return ring.slice();
}

export function clearAuditEntries(): void {
  ring.length = 0;
}
